// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_i7-a";
export var fulfillmentFormRail = "_i7-9";
export var headerTitleRow = "_i7-c";
export var orderDetailsWrapper = "_i7-7";
export var orderLinkTrigger = "_i7-2";
export var paymentInformationGrid = "_i7-h";
export var paymentSummaryColumn = "_i7-i";
export var shipmentContainer = "_i7-b";
export var shipmentDetailsMainPane = "_i7-8";
export var shipmentNavigationCard = "_i7-5";
export var shipmentNavigationRail = "_i7-3";
export var shipmentNavigationRailHeader = "_i7-4";
export var shipmentSummaryFact = "_i7-e";
export var shipmentSummaryGrid = "_i7-d";
export var shipmentSummaryMetadataRow = "_i7-f";
export var shipmentSummaryTags = "_i7-g";
export var shipmentWorkspace = "_i7-0";
export var shipmentWorkspaceContent = "_i7-6";
export var shipmentWorkspaceHeader = "_i7-1";